import lodash from "lodash";
import { Dict } from "../ui/hooks/useDict";

export interface Added<A> {
  key: string;
  newValue: A;
}

export interface Removed<A> {
  key: string;
  oldValue: A;
}

export interface Updated<A> {
  key: string;
  oldValue: A;
  newValue: A;
}

export interface Diffs<A> {
  added: Array<Added<A>>;
  removed: Array<Removed<A>>;
  updated: Array<Updated<A>>;
}

type Same<A> = (x: A, y: A) => boolean;

const eq = <A>(x: A, y: A) => x === y;

export default function diffDicts<A>(
  curr: Dict<A>,
  prev: Dict<A>,
  same: Same<A> = eq
): Diffs<A> {
  const added: Array<Added<A>> = [];
  const removed: Array<Removed<A>> = [];
  const updated: Array<Updated<A>> = [];

  lodash.each(prev, (oldValue, key) => {
    if (oldValue == null) return;

    const newValue = curr[key];

    if (newValue == null) {
      removed.push({ key, oldValue });
    } else if (!same(oldValue, newValue)) {
      updated.push({ key, oldValue, newValue });
    }
  });

  lodash.each(curr, (newValue, key) => {
    if (newValue == null) return;

    const oldValue = prev[key];

    if (oldValue == null) {
      added.push({ key, newValue });
    }
  });

  return { added, removed, updated };
}
